"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seedRelatedMap = exports.seedRelatedAlias = exports.mapRelatedAlias = void 0;
exports.sortToken = sortToken;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _default = _interopRequireDefault(require("antd/es/theme/themes/default"));
var _seed = _interopRequireDefault(require("antd/es/theme/themes/seed"));
var _alias = _interopRequireDefault(require("antd/es/theme/util/alias"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Alias Token 优先级排序，数字小的排在前面，在 map 中的优先级比不在 map 中的优先级高，都不在 map 中的按字母顺序排序
var tokenOrder = {
  // example
  // 0-20 留给 text
  colorTextHeading: 1,
  colorTextLabel: 2,
  colorTextDescription: 3,
  colorTextDisabled: 4,
  colorTextPlaceholder: 5,
  colorIcon: 10,
  colorIconHover: 11,
  // 21-40 留给 border
  colorBorderBg: 21,
  controlTmpOutline: 22,
  // 41-60 留给 fill
  colorFillAlter: 41,
  colorFillContent: 42,
  colorFillContentHover: 43,
  // 61-80 留给 bg
  controlItemBgActive: 61,
  controlItemBgActiveHover: 62,
  controlItemBgHover: 63
};
function sortToken(arr) {
  if (!arr) {
    return arr;
  }
  return arr.sort(function (a, b) {
    if (tokenOrder[a] && !tokenOrder[b]) {
      return -1;
    }
    if (!tokenOrder[a] && tokenOrder[b]) {
      return 1;
    }
    if (tokenOrder[a] && tokenOrder[b]) {
      return tokenOrder[a] - tokenOrder[b];
    }
    return a.localeCompare(b);
  });
}
var seedRelatedMap = exports.seedRelatedMap = {
  colorPrimary: ['colorPrimaryBg', 'colorPrimaryBgHover', 'colorPrimaryBorder', 'colorPrimaryBorderHover', 'colorPrimaryHover', 'colorPrimary', 'colorPrimaryActive', 'colorPrimaryTextHover', 'colorPrimaryText', 'colorPrimaryTextActive'],
  colorError: ['colorErrorBg', 'colorErrorBgHover', 'colorErrorBorder', 'colorErrorBorderHover', 'colorErrorHover', 'colorError', 'colorErrorActive', 'colorErrorTextHover', 'colorErrorText', 'colorErrorTextActive'],
  colorWarning: ['colorWarningBg', 'colorWarningBgHover', 'colorWarningBorder', 'colorWarningBorderHover', 'colorWarningHover', 'colorWarning', 'colorWarningActive', 'colorWarningTextHover', 'colorWarningText', 'colorWarningTextActive'],
  colorSuccess: ['colorSuccessBg', 'colorSuccessBgHover', 'colorSuccessBorder', 'colorSuccessBorderHover', 'colorSuccessHover', 'colorSuccess', 'colorSuccessActive', 'colorSuccessTextHover', 'colorSuccessText', 'colorSuccessTextActive'],
  colorInfo: ['colorInfoBg', 'colorInfoBgHover', 'colorInfoBorder', 'colorInfoBorderHover', 'colorInfoHover', 'colorInfo', 'colorInfoActive', 'colorInfoTextHover', 'colorInfoText', 'colorInfoTextActive'],
  colorLink: ['colorLinkHover', 'colorLinkActive'],
  colorTextBase: ['colorText', 'colorTextSecondary', 'colorTextTertiary', 'colorTextQuaternary'],
  colorBgBase: ['colorBgContainer', 'colorBgElevated', 'colorBgLayout', 'colorBgSpotlight', 'colorBgMask', 'colorBorder', 'colorBorderSecondary', 'colorFill', 'colorFillSecondary', 'colorFillTertiary', 'colorFillQuaternary']
};
var getMapRelatedAlias = function getMapRelatedAlias() {
  var mapRelatedAlias = {};
  var mapFn = _default.default;
  var mapToken = mapFn(_objectSpread({}, _seed.default));
  var aliasToken = (0, _alias.default)(_objectSpread(_objectSpread({}, mapToken), {}, {
    override: {}
  }));
  Object.keys(mapToken).forEach(function (mapKey) {
    delete aliasToken[mapKey];
  });
  Object.keys(mapToken).forEach(function (mapKey) {
    var newAlias = (0, _alias.default)(_objectSpread(_objectSpread({}, mapToken), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, mapKey, 'changed'), "override", {})));
    Object.keys(aliasToken).forEach(function (aliasKey) {
      if (aliasToken[aliasKey] !== newAlias[aliasKey]) {
        if (!mapRelatedAlias[mapKey]) {
          mapRelatedAlias[mapKey] = [];
        }
        mapRelatedAlias[mapKey].push(aliasKey);
      }
    });
    mapRelatedAlias[mapKey] = sortToken(mapRelatedAlias[mapKey]);
  });
  return mapRelatedAlias;
};
var mapRelatedAlias = exports.mapRelatedAlias = getMapRelatedAlias();
var getSeedRelatedAlias = function getSeedRelatedAlias() {
  var result = {};
  Object.keys(_seed.default).forEach(function (key) {
    var _seedRelatedMap$seedK;
    var seedKey = key;
    var arr = mapRelatedAlias[seedKey] || [];
    (_seedRelatedMap$seedK = seedRelatedMap[seedKey]) === null || _seedRelatedMap$seedK === void 0 || _seedRelatedMap$seedK.forEach(function (mapKey) {
      var _mapRelatedAlias$mapK;
      arr.push.apply(arr, (0, _toConsumableArray2.default)((_mapRelatedAlias$mapK = mapRelatedAlias[mapKey]) !== null && _mapRelatedAlias$mapK !== void 0 ? _mapRelatedAlias$mapK : []));
    });
    if (arr.length) {
      result[key] = sortToken(Array.from(new Set(arr)));
    }
  });
  return result;
};
var seedRelatedAlias = exports.seedRelatedAlias = getSeedRelatedAlias();